import { http } from "@di";
import actions from "./actions";
import repositories from "./repositories";
import useCases from "./useCases";
import presenters from "./presenters";
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    basicProfile: cPresenters.basicProfile,
};
